module.exports = __webpack_public_path__ + "img/quote-katrina-hood.cead0b97.png";